<template>
  <div class="hawk-crm-banner-area">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="hawk-banner-content">
            <div class="badge-hero mb-3" data-aos="fade-right">
              <i class="ph-shield-check"></i>
              <span>Self-Hosted • 100% Seus Dados</span>
            </div>

            <h1 data-aos="fade-right" data-aos-delay="100">
              Controle Total do Seu
              <span class="gradient-text">Funil de Vendas</span>
              com HawkCRM
            </h1>

            <p data-aos="fade-right" data-aos-delay="200">
              O CRM self-hosted que coloca VOCÊ no comando. Pipelines personalizáveis,
              gestão completa de propostas, automação inteligente e seus dados 100% seguros
              na sua própria infraestrutura.
            </p>

            <div class="feature-badges mb-4" data-aos="fade-right" data-aos-delay="300">
              <div class="feature-badge">
                <i class="ph-cloud-slash"></i>
                <span>Self-Hosted</span>
              </div>
              <div class="feature-badge">
                <i class="ph-lock-key"></i>
                <span>Dados Seguros</span>
              </div>
              <div class="feature-badge">
                <i class="ph-infinity"></i>
                <span>Ilimitado</span>
              </div>
            </div>

            <div class="banner-cta-group" data-aos="fade-right" data-aos-delay="400">
              <a href="https://wa.me/5554992302401?text=Quero testar o HawkCRM gratuitamente por 30 dias!"
                 target="_blank"
                 class="btn-style-one green-color"
                 rel="noopener noreferrer">
                Teste Grátis por 30 Dias
                <i class="ph-caret-right"></i>
              </a>
              <a href="#pricing" class="btn-style-one outline-color">
                Ver Planos
                <i class="ph-caret-right"></i>
              </a>
            </div>

            <div class="trust-info" data-aos="fade-right" data-aos-delay="500">
              <i class="ph-check-circle"></i>
              <span>Sem cartão de crédito • Cancele quando quiser</span>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12">
          <div class="hawk-banner-image" data-aos="fade-up">
            <div class="image-wrapper">
              <img src="../../assets/images/banner/banner9.png" alt="HawkCRM Dashboard">

              <!-- Floating Stats Cards -->
              <div class="floating-stat stat-1">
                <div class="stat-icon">
                  <i class="ph-chart-line-up"></i>
                </div>
                <div class="stat-content">
                  <span class="stat-number">+347%</span>
                  <span class="stat-label">Conversão</span>
                </div>
              </div>

              <div class="floating-stat stat-2">
                <div class="stat-icon">
                  <i class="ph-users-three"></i>
                </div>
                <div class="stat-content">
                  <span class="stat-number">1.2k+</span>
                  <span class="stat-label">Clientes Ativos</span>
                </div>
              </div>

              <div class="floating-stat stat-3">
                <div class="stat-icon">
                  <i class="ph-trophy"></i>
                </div>
                <div class="stat-content">
                  <span class="stat-number">98%</span>
                  <span class="stat-label">Satisfação</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Background Tech Elements -->
    <div class="tech-background">
      <div class="grid-pattern"></div>
      <div class="geometric-shape shape-circle"></div>
      <div class="geometric-shape shape-square"></div>
      <div class="geometric-shape shape-triangle"></div>
      <div class="code-particle particle-1">CRM</div>
      <div class="code-particle particle-2">{ }</div>
      <div class="code-particle particle-3">ERP</div>
      <div class="code-particle particle-4">API</div>
      <div class="gradient-orb orb-1"></div>
      <div class="gradient-orb orb-2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainBanner'
}
</script>

<style scoped>
/* ===== BANNER BASE ===== */
.hawk-crm-banner-area {
  position: relative;
  background: linear-gradient(135deg, #0a0a1a 0%, #16213e 50%, #1a1a2e 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 120px 0 80px;
  overflow: hidden;
}

/* ===== TECH BACKGROUND ===== */
.tech-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}

.grid-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
      linear-gradient(rgba(109, 93, 252, 0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(109, 93, 252, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

.geometric-shape {
  position: absolute;
  opacity: 0.06;
  animation: floatShape 20s ease-in-out infinite;
}

.shape-circle {
  width: 300px;
  height: 300px;
  border: 3px solid #6D5DFC;
  border-radius: 50%;
  top: 10%;
  right: 5%;
}

.shape-square {
  width: 200px;
  height: 200px;
  border: 3px solid #4361EE;
  transform: rotate(45deg);
  bottom: 20%;
  left: 10%;
  animation-delay: 5s;
}

.shape-triangle {
  width: 0;
  height: 0;
  border-left: 100px solid transparent;
  border-right: 100px solid transparent;
  border-bottom: 173px solid #8A7DFF;
  top: 60%;
  right: 20%;
  animation-delay: 10s;
}

@keyframes floatShape {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(30px, -30px) rotate(90deg); }
  50% { transform: translate(-20px, 20px) rotate(180deg); }
  75% { transform: translate(20px, 30px) rotate(270deg); }
}

.code-particle {
  position: absolute;
  color: rgba(109, 93, 252, 0.4);
  font-family: 'Courier New', monospace;
  font-weight: bold;
  font-size: 20px;
  animation: floatParticle 15s ease-in-out infinite;
}

.particle-1 {
  top: 15%;
  left: 20%;
  font-size: 24px;
}

.particle-2 {
  top: 70%;
  right: 15%;
  font-size: 28px;
  animation-delay: 3s;
}

.particle-3 {
  top: 40%;
  left: 10%;
  font-size: 22px;
  animation-delay: 6s;
}

.particle-4 {
  bottom: 30%;
  right: 25%;
  font-size: 20px;
  animation-delay: 9s;
}

@keyframes floatParticle {
  0%, 100% {
    transform: translateY(0) translateX(0);
    opacity: 0.4;
  }
  50% {
    transform: translateY(-50px) translateX(30px);
    opacity: 0.7;
  }
}

.gradient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  animation: pulseOrb 10s ease-in-out infinite;
}

.orb-1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(109, 93, 252, 0.15) 0%, transparent 70%);
  top: -150px;
  right: -150px;
}

.orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(67, 97, 238, 0.12) 0%, transparent 70%);
  bottom: -150px;
  left: -150px;
  animation-delay: 5s;
}

@keyframes pulseOrb {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}

/* ===== CONTENT ===== */
.hawk-banner-content {
  position: relative;
  z-index: 2;
}

.hawk-banner-content h1,
.hawk-banner-content p {
  color: #ffffff;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.hawk-banner-content h1 {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 20px;
}

.badge-hero {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(37, 211, 102, 0.15);
  border: 1px solid rgba(37, 211, 102, 0.4);
  padding: 8px 16px;
  border-radius: 50px;
  font-weight: 600;
  color: #5FE39C;
  font-size: 14px;
  backdrop-filter: blur(10px);
}

.badge-hero i {
  font-size: 18px;
  color: #25D366;
}

.gradient-text {
  background: linear-gradient(135deg, #C5BFFF 0%, #9FB0FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hawk-banner-content p {
  font-size: 18px;
  line-height: 1.7;
  margin-bottom: 30px;
  color: #b8b8b8;
}

/* ===== FEATURE BADGES ===== */
.feature-badges {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.feature-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.08);
  padding: 10px 16px;
  border-radius: 25px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.feature-badge i {
  font-size: 20px;
  color: #6D5DFC;
}

.feature-badge span {
  color: #e0e0e0;
  font-size: 14px;
  font-weight: 600;
}

/* ===== CTA BUTTONS ===== */
.banner-cta-group {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.btn-style-one {
  padding: 15px 30px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn-style-one.green-color {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border: 2px solid #25D366;
  color: white;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
}

.btn-style-one.green-color:hover {
  background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.5);
}

.btn-style-one.outline-color {
  background: rgba(255, 255, 255, 0.08);
  border: 2px solid rgba(109, 93, 252, 0.6);
  color: #C5BFFF;
  backdrop-filter: blur(10px);
}

.btn-style-one.outline-color:hover {
  background: rgba(109, 93, 252, 0.3);
  border-color: #8A7DFF;
  color: white;
}

/* ===== TRUST INFO ===== */
.trust-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #b8b8b8;
  font-size: 14px;
}

.trust-info i {
  color: #25D366;
  font-size: 20px;
}

/* ===== IMAGE SECTION ===== */
.hawk-banner-image {
  position: relative;
  z-index: 2;
}

.image-wrapper {
  position: relative;
}

.image-wrapper img {
  width: 100%;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(109, 93, 252, 0.3);
}

/* ===== FLOATING STATS ===== */
.floating-stat {
  position: absolute;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  padding: 15px 20px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 12px;
  animation: float 3s ease-in-out infinite;
  border: 2px solid rgba(109, 93, 252, 0.2);
}

.stat-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon i {
  font-size: 24px;
  color: white;
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
}

.stat-label {
  font-size: 12px;
  color: #666;
}

.stat-1 {
  top: 15%;
  right: 10%;
  animation-delay: 0s;
}

.stat-2 {
  bottom: 25%;
  right: 5%;
  animation-delay: 1s;
}

.stat-3 {
  top: 45%;
  left: 5%;
  animation-delay: 2s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 991px) {
  .hawk-crm-banner-area {
    min-height: auto;
    padding: 100px 0 60px;
  }

  .hawk-banner-content h1 {
    font-size: 32px;
  }

  .feature-badges,
  .banner-cta-group {
    justify-content: center;
  }

  .trust-info {
    justify-content: center;
  }

  .floating-stat,
  .code-particle,
  .geometric-shape {
    display: none;
  }

  .hawk-banner-image {
    margin-top: 40px;
  }
}

@media (max-width: 768px) {
  .hawk-banner-content h1 {
    font-size: 28px;
  }

  .hawk-banner-content p {
    font-size: 16px;
  }

  .btn-style-one {
    width: 100%;
    justify-content: center;
  }
}
</style>